import { render, staticRenderFns } from "./EksternalPlatform.vue?vue&type=template&id=0f08de2e&scoped=true&"
import script from "./EksternalPlatform.vue?vue&type=script&lang=js&"
export * from "./EksternalPlatform.vue?vue&type=script&lang=js&"
import style0 from "./EksternalPlatform.vue?vue&type=style&index=0&id=0f08de2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f08de2e",
  null
  
)

export default component.exports